<template>
  <v-container class="login-container" fluid>
    <v-row class="fill-height" no-gutters>
      <!-- Left Section with Background Image -->
      <v-col cols="12" md="6" lg="8" class="hidden-sm-and-down">
        <div class="background-image">
          <div class="overlay">
            <div class="welcome-content">
                          <v-img
              :src="logo"
              contain
              class="logo mb-3"
            />
              <h1 class="welcome-title">Account Recovery</h1>
              <p class="welcome-description">
                Reset your password and regain access to your account
              </p>
            </div>
          </div>
        </div>
      </v-col>

      <!-- Right Section - Form -->
      <v-col cols="12" md="6" lg="4" class="form-section">
        <v-card class="auth-card" flat>
          <v-card-title class="justify-center pt-10 pb-5">
            <!-- <v-img
              :src="logo"
              max-width="287"
              contain
              class="logo"
            /> -->
          </v-card-title>

          <v-card-text class="px-8">
            <div class="text-center mb-8">
              <h2 class="app-bold-font mb-2">Forgot Password?</h2>
              <p class="text--secondary">
                Enter your email or phone number to receive a reset code
              </p>
            </div>

            <v-form ref="form">
              <v-text-field
                v-model="emailPhone"
                label="Email or Phone number"
                outlined
                dense
                rounded
                background-color="white"
                class="mb-4"
                @change="onChange"
                :error-messages="errorMessage"
                :rules="[rules.required]"
              />

              <v-btn
                block
                x-large
                rounded
                color="#0A5B8A"
                class="mt-6"
                @click="sendCode"
                :loading="loading"
                dark
              >
                Send Verification Code
              </v-btn>

              <div class="text-center mt-4">
                <v-btn
                  text
                  color="primary"
                  class="text-none"
                  @click="goBack"
                >
                  <v-icon left small>mdi-arrow-left</v-icon>
                  Back to Login
                </v-btn>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      emailPhone: "",
      loading: false,
      errorMessage: null,
      rules: {
        required: value => !!value || "Required"
      }
    };
  },
    computed: {
    logo() {
      // resolve the logo file based on .env string
      return require(`@/assets/${process.env.VUE_APP_LOGO}`);
    }
  },
  methods: {
    ...mapActions({
      onForgotPassword: "auth/onForgotPassword"
    }),
    emailIsValid(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },
    phoneIsValid(number) {
      return /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/g.test(
        number
      );
    },
    sendCode() {
      if (this.loading) return;
      
      let email = "";
      let phone = "";
      
      if (this.emailIsValid(this.emailPhone)) {
        email = this.emailPhone;
      } else if (this.phoneIsValid(this.emailPhone)) {
        phone = this.emailPhone;
      } else if (!this.emailPhone) {
        this.errorMessage = "Please enter your email or phone number";
        return;
      } else {
        this.errorMessage = "Invalid email or phone format";
        return;
      }

      const params = { email, phone };
      this.loading = true;
      
      this.onForgotPassword(params)
        .then(() => {
          this.$router.push({ name: "verification-code", params });
        })
        .catch(error => {
          this.loading = false;
          this.errorMessage = error.response?.data?.message || error.message;
        });
    },
    onChange() {
      this.errorMessage = null;
    },
    goBack() {
      this.$router.push({ name: "login" });
    }
  }
};
</script>

<style scoped>
.login-container {
  height: 100vh;
  padding: 0;
}

.background-image {
  background-image: url(../../assets/bg_login.jpg);
  background-size: cover;
  background-position: center;
  height: 100%;
  position: relative;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(10, 91, 138, 0.7) 0%,
    rgba(36, 163, 154, 0.6) 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
}

.welcome-content {
  max-width: 80%;
  color: white;
  text-align: center;
}

.welcome-title {
  font-family: "Poppins-Bold";
  font-size: 3rem;
  line-height: 1.2;
  margin-bottom: 1rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.welcome-description {
  font-family: "Poppins-Medium";
  font-size: 1.2rem;
  opacity: 0.9;
}

.form-section {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f9fa;
}

.auth-card {
  width: 100%;
  max-width: 450px;
  border-radius: 16px !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08) !important;
  background-color: white;
}

.logo {
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.05);
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .welcome-title {
    font-size: 2.5rem;
  }
  
  .welcome-description {
    font-size: 1rem;
  }
}

@media (max-width: 600px) {
  .auth-card {
    border-radius: 0 !important;
    box-shadow: none !important;
  }
  
  .form-section {
    padding: 0;
  }
}

.v-messages__message {
  padding-top: 2px;
}
</style>